import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBevelIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			strokeDasharray: "2 2",
			d: "M6 20V4h14",
			opacity: .25
		}),
		/* @__PURE__ */ _jsx("path", { d: "M6 20v-7q0-9 9-9h5" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6,
			cy: 13,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 4,
			r: 1.5,
			fill: "currentColor",
			stroke: "none"
		})
	]
});
export default SvgBevelIcon;
